<app-alert></app-alert>

<div class="row mt-2">
    <div class="form-group col mb-n1">
        <h1>Survey</h1>
    </div>
</div>

<ngx-datatable
    #table
    class="bootstrap-table mb-3 mt-2"
    [rows]="items"
    [headerHeight]="61"
    [footerHeight]="38"
    [rowHeight]="'auto'"
    [columnMode]="'standard'"
    [scrollbarH]="true"
    [count]="totalItems"
    [offset]="0"
    [limit]="20"
>
    <ngx-datatable-column name="Rate" prop="rate" [cellClass]="'tb-col-2'" [headerClass]="'tb-col-2'" [draggable]="false" [resizeable]="false">
        <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
            <div>
                {{ value }}
            </div>
            <div class="cells-mobile">
                <div class="cell-value-line">{{ row.message }}</div>
                <div class="cell-value-line">{{ row.phone }}</div>
            </div>
        </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column
        name="Message"
        prop="message"
        [cellClass]="'tb-col-2 mobile-hide'"
        [headerClass]="'tb-col-2 mobile-hide'"
        [draggable]="false"
        [resizeable]="false"
    >
        <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
            <div>
                {{ value }}
            </div>
        </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column
        name="Phone"
        prop="phone"
        [cellClass]="'tb-col-2 mobile-hide'"
        [headerClass]="'tb-col-2 mobile-hide'"
        [draggable]="false"
        [resizeable]="false"
    >
        <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
            <div>{{ value }}</div>
        </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-footer>
        <ng-template ngx-datatable-footer-template let-rowCount="rowCount" let-pageSize="pageSize" let-curPage="curPage">
            <datatable-pager
                [pagerLeftArrowIcon]="'datatable-icon-left'"
                [pagerRightArrowIcon]="'datatable-icon-right'"
                [pagerPreviousIcon]="'datatable-icon-prev'"
                [pagerNextIcon]="'datatable-icon-skip'"
                [page]="curPage"
                [size]="pageSize"
                [count]="rowCount"
                [hidden]="!(rowCount / pageSize > 1)"
                (change)="table.onFooterPage($event)"
            >
            </datatable-pager>
        </ng-template>
    </ngx-datatable-footer>
</ngx-datatable>
